import React from 'react'
import HistoryCard from './HistoryCard'
import classNames from 'classnames'

import style from './PaymentHistoryEntries.module.scss'

export default function PaymentHistoryEntries({
  isMobile,
  historyEntries,
  historyType,
}) {
  return (
    <div className="zb-card">
      {historyEntries.size ? (
        historyEntries.map((record, i) => (
          <HistoryCard
            key={i}
            className={classNames(
              `js-history-card-${i}`,
              { [style.pointed]: !isMobile },
              'legacyPointed'
            )}
            history={record}
          />
        ))
      ) : (
        <HistoryCard
          key="empty-card"
          className={classNames(
            'js-history-card-0',
            { [style.pointed]: !isMobile },
            'legacyPointed'
          )}
          history={{
            label:
              historyType === 'Payment'
                ? 'No payments have been made as part of this agreement yet'
                : 'No Access history available yet — try again later',
          }}
        />
      )}
    </div>
  )
}
